// extracted by mini-css-extract-plugin
module.exports = {"list_container":"EmailScreenSuggestionsList_list_container__1slsa","list":"EmailScreenSuggestionsList_list__2_KzW","list_item":"EmailScreenSuggestionsList_list_item__103G8"};